module.exports = __webpack_public_path__ + "746adc5fffd5d800d80c074ba626dc0c.MP3";